import { render, staticRenderFns } from "./EventsBirthday.vue?vue&type=template&id=4bff66eb"
import script from "./EventsBirthday.vue?vue&type=script&lang=js"
export * from "./EventsBirthday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports